import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { InvoiceField } from '@/@vxapp/@Enums/PHP/ServicesV2/Invoices/DataProviders/InvoiceField'

export const InvoicesTableActions = [
  {
    id: 'mark-inactive',
    title: 'Mark Inactive',
    tooltip: 'Mark Invoice as Inactive',
    icon: 'tabler-edit-off',
    color: 'secondary',
    disabled: false,
    hidden: false,
    emit: 'mark-inactive',
  },
  {
    id: 'mark-paid',
    title: 'Mark Paid',
    tooltip: 'Mark Invoice as Paid',
    icon: 'tabler-check',
    color: 'success',
    disabled: false,
    hidden: false,
    emit: 'mark-paid',
  },
  {
    id: 'preview',
    title: PageMeta.Invoices.Preview.Title,
    icon: PageMeta.Invoices.Preview.Icon,
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Invoices.Preview.Name || '',
      paramKey: 'guid',
      itemKey: InvoiceField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
  {
    id: 'service',
    title: PageMeta.Invoices.Service.Title,
    tooltip: PageMeta.Invoices.Service.Tooltip ?? undefined,
    icon: PageMeta.Invoices.Service.Icon,
    color: 'success',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Invoices.Service.Name || '',
      paramKey: 'guid',
      itemKey: InvoiceField.DB_IDENTIFIER,
    },
    emit: 'service',
  },
  {
    id: 'messages-drawer',
    title: 'Messages Drawer',
    tooltip: 'Open Messages Drawer',
    icon: 'tabler-send',
    color: 'info',
    disabled: false,
    hidden: false,
    emit: 'messages-drawer',
  },
] as const satisfies readonly TableActionSpec[]
